import {Directive, ElementRef, Output, EventEmitter, HostListener} from '@angular/core';

@Directive({
    selector: '[appClickOutiside]',
    standalone: false
})
export class ClickOutisideDirective {
    @Output() clickOutside = new EventEmitter<void>();

    constructor(private eRef: ElementRef) {
    }

    @HostListener('document:click', ['$event'])
    onClickOut = (event: any) => {
        if (!this.eRef.nativeElement.contains(event.target) && this.checkIfElementIsWithinViewport(this.eRef.nativeElement)) {
            this.clickOutside.emit();
        }
    };

    private checkIfElementIsWithinViewport = (element: any) => {
        if ((element != undefined)) {
            const element_offset = element.getBoundingClientRect();
            return (
                (element_offset.top >= 0) &&
                (element_offset.left >= 0) &&
                (element_offset.bottom <= window.innerHeight) &&
                (element_offset.right <= window.innerWidth)
            );
        } else {
            return false;
        }
    }
}
